import { useState, useEffect } from 'react';
import translation from 'i18n/translation.json';
import { Menu } from '../constants';
import { RouterUrl } from 'routes';

const LIBRO_IMG_URL = `${process.env.PUBLIC_URL}/images/libro-de-reclamaciones.png`;

export interface IMenuLink {
  link: string;
  text: string;
  account: boolean;
  footer: boolean;
  altText?: string;
  img?: string;
}

export const useMenuItems = (target: 'account' | 'footer' | 'web') => {
  const [menuItems, setMenuItems] = useState<IMenuLink[]>([]);

  const { header, footer } = translation;

  const items = [
    {
      link: Menu.HowToBorrow,
      text: header.borrow,
      altText: header.moneyin3Steps,
      account: true,
      footer: true,
      web: true,
    },
    { link: Menu.HowToRepay, text: header.repay, account: true, footer: false, web: true },
    { link: Menu.TermAndConditions, text: header.terms, account: false, footer: true, web: false },
    { link: Menu.FAQ, text: header.faqFull, account: true, footer: true, web: true },
    { link: Menu.AboutUs, text: header.about, account: true, footer: false, web: true },
    { link: Menu.PolicyPrivacy, text: footer.privacyPolicy, account: false, footer: true, web: false },
    {
      link: RouterUrl.Reclamation,
      text: footer.claimBook,
      account: false,
      footer: true,
      web: false,
      img: LIBRO_IMG_URL,
    },
  ];

  useEffect(() => {
    const filteredItems = items.filter(item => item[target]);
    setMenuItems(filteredItems);
  }, [target]);

  return { menuItems };
};
